import { useQuery } from '@tanstack/react-query';
import { fetchSchedules } from '../api/schedules';

export function useSchedules(options = {}) {
  return useQuery({
    queryKey: ['schedules'],
    queryFn: fetchSchedules,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    ...options,
  });
}
